<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-22                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
  <b-card no-body>
    <b-card-header header-bg-variant="secondary" header-text-variant="light">Summary</b-card-header>
    <b-list-group :style="list_style">
      <b-list-group-item v-for="node in summary_nodes" :key="node.id"
                         class="px-3 py-1 d-flex justify-content-between">
        <span>{{node.name}}</span>
        <span>
            <b-badge v-if="getNodePrice(node) !== 0">{{formatCurrency(getNodePrice(node))}}</b-badge>
          </span>
      </b-list-group-item>
    </b-list-group>
  <slot name="footer" v-bind:data="{part_number:part_number,calculated_total_price:calculated_total_price}">
    <b-card-footer footer-bg-variant="light" class="pt-1 pb-1">
      <b-form-group label="SKU" label-cols="4" label-align="right" label-class="text-danger font-weight-bold" class="mb-0"><span class="form-control-plaintext font-weight-bold">{{part_number}}</span></b-form-group>
      <b-form-group label="Total" label-cols="4" label-align="right" label-class="text-danger font-weight-bold" class="mb-0"><span class="form-control-plaintext font-weight-bold">{{formatCurrency(calculated_total_price)}}</span></b-form-group>
      <b-form-group v-if="debugEnabled && debug_message" label="Debug" label-cols="4" label-align="right" label-class="text-danger font-weight-bold" class="mb-0"><span class="form-control-plaintext font-weight-bold">{{debug_message}}</span></b-form-group>
    </b-card-footer>
  </slot>
  </b-card>
  <slot name="after_footer" v-bind:data="{part_number:part_number,calculated_total_price:calculated_total_price}">
  </slot>
  </div>
</template>

<script>
import ConfigurationTemplateVersion from "../../business-objects/configuration-template-version";
import YesNo from "../../enums/yes-no";
import QuoteProduct from "../../business-objects/quote-product";
import useCurrencyFormatter from "../../compositions/use-currency-formatter";

export default {
  name: "configuration-summary",
  props: {
    templateVersion: {
      type: ConfigurationTemplateVersion,
      required: true
    },
    priceName:{
      type:String,
      required: true
    },
    quoteProduct:{
      type: QuoteProduct,
      required: true
    },
    listHeight:{
      type:Number,
      default:400
    },
    debugEnabled:{
      type:Boolean,
      default:false
    }
  },
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  },
  computed: {
    list_style(){
      return {'max-height':`${this.listHeight}px`,'overflow-y': 'auto'};
    },
    sorted_selected_nodes(){
      return this.templateVersion.selected_nodes
          .sort((node1,node2)=>{
            if(node1.attribute_store['category-order'] < node2.attribute_store['category-order']){
              return -1;
            }
            if(node1.attribute_store['category-order'] > node2.attribute_store['category-order']){
              return 1;
            }
            return 0;
          });
    },
    summary_nodes(){
      return this.sorted_selected_nodes.filter((node) => {
        return node.attribute_store['item-type'] === 'content' &&
            node.attribute_store['hide-on-summary'] !== YesNo.YES;
      });
    },
    calculated_total_price(){
      return this.templateVersion.selected_nodes.reduce((sum,node)=>{
        sum += this.getNodePrice(node);
        return sum;
      },0)
    },
    combination_string(){
      return this.templateVersion.selected_nodes
          .filter((node)=>{ return node.attribute_store['cic-is-part-lookup'] !== 'NO'})
          .sort((node1,node2)=>{
            if(node1.attribute_store['kiosk-code'] < node2.attribute_store['kiosk-code']){
              return -1;
            }
            if(node1.attribute_store['kiosk-code'] > node2.attribute_store['kiosk-code']){
              return 1;
            }
            return 0;
          })
          .map((node)=>{ return node.attribute_store['kiosk-code'];})
          .join('|');
    },
    prefix(){
      return this.templateVersion.attribute_store['cfg-template-part-lookup-prefix'];
    }
  },
  watch: {
    combination_string() {
      if(!!this.combination_string && this.prefix){
        this.$store.dispatch('MacroResultsStore/execute',{
          id:'tais_bid_get_config_code',part_lookup_prefix:this.prefix,combination:this.combination_string})
            .then((result)=>{
              this.part_number = result.response;
              this.debug_message = result.debug_message;
              this.quoteProduct.name = result.response;
            })
            .catch((error)=>{
              this.part_number = error.response.data.response;
            });
      }
    }
  },
  data(){
    return {
      part_number: null,
      debug_message: null
    };
  },
  methods:{
    getNodePrice(node){
      let price = node.calculated_price_transformations[this.priceName];
      if(price === undefined || price === null){
        price = '0';
      }
      return parseFloat(price);
    }
  }
}
</script>

<style scoped>

</style>
